import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted } from "vue"
import { useRouter } from "vue-router/composables"

import SyncListTable from "@/modules/sync/_components/SyncListTable.vue"
import { useSyncListStore } from "@/modules/sync/store/useSyncListStore"

// Store & Route

const __default__ = {
  metaInfo() {
    return {
      titleTemplate: `%s - ${this.$t("synchronization.title")}`
    }
  }
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SyncList',
  setup(__props) {

const syncListStore = useSyncListStore()
const router = useRouter()
// End Store & Route

// Methods
const goToCreateSynchronization = () => {
  router.push({ name: "sync-create" })
}
// End Methods

// Lifecycle
onMounted(() => {
  syncListStore.getSynchronizations().then((data) => {
    syncListStore.getSyncDraftsMeta(data.results.map((sync) => sync.uuid))
  })
})
onBeforeUnmount(() => {
  syncListStore.stopTaskPolling()
})
// End Lifecycle

return { __sfc: true,syncListStore, router, goToCreateSynchronization, SyncListTable }
}

})